import React, { useEffect, useRef } from 'react';
import p5 from 'p5';

const Globe = () => {
  const containerRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const sketch = (p) => {
      let numParticles = 2000;
      let numExtraParticles = 800;
      let phi = [], theta = [], phiSpeed = [], thetaSpeed = [], sizes = [], isExtra = [];
      let sphereRadius = 250;
      let time = 0;
      let mouseInfluence = 150;

      p.setup = () => {
        if (!containerRef.current) return; 
        const canvas = p.createCanvas(containerRef.current.offsetWidth, containerRef.current.offsetHeight);
        canvas.parent(containerRef.current);
        canvasRef.current = canvas;

        for (let i = 0; i < numParticles + numExtraParticles; i++) {
          phi[i] = p.random(p.TWO_PI);
          theta[i] = p.acos(p.random(-1, 1));
          phiSpeed[i] = i < numParticles ? p.random(-0.005, 0.005) : p.random(-0.01, 0.01);
          thetaSpeed[i] = i < numParticles ? p.random(-0.0025, 0.0025) : p.random(-0.005, 0.005);
          sizes[i] = i < numParticles ? p.random(1, 3) : p.random(0.5, 2);
          isExtra[i] = i >= numParticles;
        }
      };

      p.draw = () => {
        if (!containerRef.current) return; 
        p.resizeCanvas(containerRef.current.offsetWidth, containerRef.current.offsetHeight);
        let centerX = p.width / 2;
        let centerY = p.height / 2;
        let mouseRelX = p.mouseX - centerX;
        let mouseRelY = p.mouseY - centerY;
        let mouseDistanceFromCenter = p.sqrt(mouseRelX * mouseRelX + mouseRelY * mouseRelY);
        let mouseOutsideSphere = mouseDistanceFromCenter > sphereRadius;
        p.noStroke();
        p.fill(153, 69, 255);

        let rotationY = time * 0.3;
        let rotationX = p.sin(time * 0.2) * 0.2;

        for (let i = 0; i < numParticles + numExtraParticles; i++) {
          phi[i] += phiSpeed[i];
          theta[i] += thetaSpeed[i];
          theta[i] = p.constrain(theta[i], 0, p.PI);

          let x3d = sphereRadius * p.sin(theta[i]) * p.cos(phi[i]);
          let y3d = sphereRadius * p.sin(theta[i]) * p.sin(phi[i]);
          let z3d = sphereRadius * p.cos(theta[i]);

          let x_rotY = x3d * p.cos(rotationY) - z3d * p.sin(rotationY);
          let z_rotY = x3d * p.sin(rotationY) + z3d * p.cos(rotationY);

          let y_rotX = y3d * p.cos(rotationX) - z_rotY * p.sin(rotationX);
          let z_final = y3d * p.sin(rotationX) + z_rotY * p.cos(rotationX);

          let screenX = x_rotY + centerX;
          let screenY = y_rotX + centerY;

          let particleSize = sizes[i];
          let depthScale = p.map(z_final, -sphereRadius, sphereRadius, 0.5, 1.5);
          particleSize *= depthScale;

          let distToMouse = p.dist(screenX, screenY, p.mouseX, p.mouseY);
          if (distToMouse < mouseInfluence) {
            let repelStrength = p.map(distToMouse, 0, mouseInfluence, 15, 0);
            let angle = p.atan2(screenY - p.mouseY, screenX - p.mouseX);
            screenX += p.cos(angle) * repelStrength;
            screenY += p.sin(angle) * repelStrength;
          }

          if (isExtra[i]) {
            if (mouseOutsideSphere) {
              if (distToMouse > mouseInfluence) continue;
              let attractionForce = 0.8;
              screenX += (p.mouseX - screenX) * attractionForce * 0.02;
              screenY += (p.mouseY - screenY) * attractionForce * 0.02;
              let intensity = p.map(distToMouse, 0, mouseInfluence, 255, 120);
              p.fill(153, 69, 255, intensity);
            } else {
              continue;
            }
          } else {
            let alpha = p.map(z_final, -sphereRadius, sphereRadius, 60, 255);
            p.fill(153, 69, 255, alpha);
          }

          p.ellipse(screenX, screenY, particleSize, particleSize);
        }

        time += 0.008;
      };

      p.windowResized = () => {
        if (!containerRef.current) return; 
        p.resizeCanvas(containerRef.current.offsetWidth, containerRef.current.offsetHeight);
      };
    };

    const p5Instance = new p5(sketch);

    return () => {
      p5Instance.remove();
    };
  }, []);

  return (
    <div id="hero" className="globe_wrapper" ref={containerRef}></div>
  );
};

export default Globe;